import { iTextarea } from "../../Models/TextareaInterface";
import Icon from "../Icon";
import {
  TextContainer,
  TextareaStyled,
  Text,
  InputTextarea,
  ErrorText,
  Span,
} from "./Textarea.styled";

const Textarea = ({
  textLabel,
  placeholder,
  errors,
  label,
  register,
  rules,
}: iTextarea) => {
  return (
    <TextareaStyled>
      <TextContainer>{textLabel && <Text>{textLabel}</Text>}</TextContainer>
      <InputTextarea
        placeholder={placeholder}
        aria-invalid={errors && errors[label] ? "true" : "false"}
        {...register(label, rules)}
      />
      {errors && errors[label] && (
        <ErrorText>
          <Icon
            icon={"alertTriangle"}
            color={"error"}
            size="small"
            fillIcon={false}
          />
          <Span>{errors[label].message}</Span>
        </ErrorText>
      )}
    </TextareaStyled>
  );
};

export default Textarea;
